import React from "react";
import FileTypeModal from "./FileTypeModal";
import { getFileName, resolveFileUrl } from "./fileUtils";

const AudioFileViewer = ({ file, open, onClose, projectId }) => {
  const fileName = getFileName(file);
  const src = resolveFileUrl(file, projectId);

  return (
    <FileTypeModal open={open} onClose={onClose} title={fileName || "Audio"}>
      <div className="h-[220px] flex items-center justify-center">
        <audio controls src={src} className="w-full">
          Your browser does not support audio playback.
        </audio>
      </div>
    </FileTypeModal>
  );
};

export default AudioFileViewer;

